// extracted by mini-css-extract-plugin
export var notificationHost = "_kh-0";